import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ExpressSectionTransport.css";
import banner from "../../assets/images/0 1.png";
import heroVideo from "../../assets/images/transirox.mp4";
import SEO from "../SEO";

export default function ExpressSectionTransport() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);

  return (
    <section className="express-transport-section py-5">
      <SEO
        title="TransCirox – Express Transport | Schnelllieferung heute noch"
        description="Express Transportdienste für sofortige Lieferungen. TransCirox vermittelt schnelle Kurier- und Expresstransporte – zuverlässig und günstig."
        keywords="Express Transport, Schnelltransport, Transport sofort, Transport heute, Expresslieferung, Kuriertransport"
      />
      <Container>
        <Row className="align-items-center justify-content-between">
          <Col xs={12} md={7} lg={7} data-aos="fade-right">
            <h2 className="express-transport-title text-orange">
              {t("expressTransport.title")}
            </h2>
            <p className="express-transport-text mt-4">
              {t("expressTransport.description")}
            </p>
            <p className="text-orange express-transport-text fw-bold">
              {t("expressTransport.qualities")}
            </p>
          </Col>
          <Col xs={12} md={5} lg={5} data-aos="zoom-in">
            <div className="image-container">
              <video
                src={heroVideo}
                autoPlay
                loop
                muted
                playsInline
                className="express-transport-video img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
